
import * as React from 'react';
import { WithItemCache, IItemCacheStateProps } from '../../../withItemCache/WithItemCache';
import { retryProgressItems } from '../../../../operations/progress/retryProgressItems';
import { makeObject } from '../../../../utilities/objects';
import { Action } from '../../../action/Action';
import { getOverallSimpleProgressBreakdown } from '../../../../operations/progress';
import { withSelectedItems } from '../../../decorators/selectors';

export interface IRetryProgressActionProps {
  itemKeys: string[];
}

/**
 * Action to retry the operations associated with progress items.
 */
export class ItemRetryProgressAction extends React.PureComponent<IRetryProgressActionProps> {
  public render(): JSX.Element {
    const {
      itemKeys
    } = this.props;

    return (
      <WithItemCache>
        { ({ itemCache, dispatch }: IItemCacheStateProps) => {
          const eligibleItemKeys = itemKeys.filter((itemKey: string) => {
            const { phase } = getOverallSimpleProgressBreakdown(itemCache, { itemKey });

            return phase === 'failed';
          });

          const onExecute = async () => {
            dispatch(retryProgressItems({
              items: makeObject(eligibleItemKeys, () => ({}))
            }));
          };

          return (
            <Action onExecute={ onExecute } isAvailable={ eligibleItemKeys.length > 0 } />
          );
        } }
      </WithItemCache>
    );
  }
}

export const RetryProgressAction = withSelectedItems()(ItemRetryProgressAction);
